import { Action } from '@ngrx/store';
import { KioskAppointment } from './kiosk.model';
import { State as KioskState, KioskError } from './kiosk.reducer';
import { IAppointmentsByHinParams } from './kiosk.service';

import { type } from '../util';

export const ActionTypes = {
  FETCH_KIOSK: type('[Kiosk] Fetch the kiosk information'),
  RESET_KIOSK: type('[Kiosk] Reset the kiosk state'),
  ADD_KIOSK_APPOINTMENT: type('[Kiosk] Add an appointment'),
  ADD_KIOSK_PATIENT: type('[Kiosk] Add a patient'),
  CONFIRM_KIOSK_APPOINTMENT: type('[Kiosk] Confirm the appointments'),
  SET_KIOSK_LOCALE: type('[Kiosk] Set the kiosk locale'),
  SET_KIOSK_ERROR: type('[Kiosk] Set a kiosk error'),
  SET_KIOSK_USER_HIN: type('[Kiosk] Set the kiosk user hin'),
  SET_KIOSK_SUBSCRIPTION_ID: type('[Kiosk] Set the kiosk subscribtion id'),
  SET_KIOSK_FETCHING_STATE: type('[Kiosk] Set the kiosk fetching state'),
  START_KIOSK_TIMER: type('[Kiosk] Start the kiosk timer'),
  STOP_KIOSK_TIMER: type('[Kiosk] Stop the kiosk timer'),
};

export class FetchKiosk implements Action {
  type = ActionTypes.FETCH_KIOSK;

  constructor(public payload: IAppointmentsByHinParams) { }
}

export class AddKioskAppointment implements Action {
  type = ActionTypes.ADD_KIOSK_APPOINTMENT;

  constructor(public payload: KioskAppointment[]) { }
}

export class AddKioskPatient implements Action {
  type = ActionTypes.ADD_KIOSK_PATIENT;

  constructor(public payload: KioskAppointment[]) { }
}

export class ResetKiosk implements Action {
  type = ActionTypes.RESET_KIOSK;
}

export class StartKioskTimer implements Action {
  type = ActionTypes.START_KIOSK_TIMER;
}

export class StopKioskTimer implements Action {
  type = ActionTypes.STOP_KIOSK_TIMER;
}

export class ConfirmKioskAppointment implements Action {
  type = ActionTypes.CONFIRM_KIOSK_APPOINTMENT;

  constructor(public payload: number) { }
}

export class SetKioskLocale implements Action {
  type = ActionTypes.SET_KIOSK_LOCALE;

  constructor(public payload: 'en' | 'fr_CA') { }
}

export class SetKioskError implements Action {
  type = ActionTypes.SET_KIOSK_ERROR;

  constructor(public payload: KioskError) { }
}

export class SetKioskUserHin implements Action {
  type = ActionTypes.SET_KIOSK_USER_HIN;

  constructor(public payload: string) { }
}

export class SetKioskSubscriptionId implements Action {
  type = ActionTypes.SET_KIOSK_SUBSCRIPTION_ID;

  constructor(public payload: number) { }
}

export class SetKioskFetchingState implements Action {
  type = ActionTypes.SET_KIOSK_FETCHING_STATE;

  constructor(public payload: boolean) { }
}

export type Actions
  = FetchKiosk
  | ResetKiosk
  | AddKioskAppointment
  | AddKioskPatient
  | ConfirmKioskAppointment
  | SetKioskLocale
  | SetKioskError
  | SetKioskUserHin
  | SetKioskSubscriptionId
  | SetKioskFetchingState
  | StartKioskTimer
  | StopKioskTimer;



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk.actions.ts